// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BankingOptionBrowseTapItemEvent
 */
export var BankingOptionBrowseTapItem = function (_a) {
    var optionId = _a.optionId, entryScreen = _a.entryScreen;
    return ({
        name: "BankingOption Browse TapItem",
        parameters: {
            cdf_entity: "BankingOption",
            cdf_action: "Browse",
            option_id: optionId !== undefined && optionId !== null ? optionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_screen: entryScreen !== undefined && entryScreen !== null ? entryScreen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BankingOptionBrowseViewItemEvent
 */
export var BankingOptionBrowseViewItem = function (_a) {
    var optionId = _a.optionId, entryScreen = _a.entryScreen;
    return ({
        name: "BankingOption Browse ViewItem",
        parameters: {
            cdf_entity: "BankingOption",
            cdf_action: "Browse",
            option_id: optionId !== undefined && optionId !== null ? optionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_screen: entryScreen !== undefined && entryScreen !== null ? entryScreen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BankingOptionBrowseStartFlowEvent
 */
export var BankingOptionBrowseStartFlow = function (_a) {
    var optionId = _a.optionId, entryScreen = _a.entryScreen, flowToken = _a.flowToken;
    return ({
        name: "BankingOption Browse StartFlow",
        parameters: {
            cdf_entity: "BankingOption",
            cdf_action: "Browse",
            option_id: optionId !== undefined && optionId !== null ? optionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_screen: entryScreen !== undefined && entryScreen !== null ? entryScreen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
